export default function Loop({ className }: { className: string }) {
  return (
    <svg className={className} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M5.52381 12C5.52381 13.6951 6.55966 15.1401 8.01266 15.6953L6.44106 16.6334C4.97216 15.6514 4 13.9431 4 12C4 8.9548 6.38781 6.48618 9.33333 6.48618H12.381V5L16.1905 7.27386L12.381 9.54773V8.06155H9.33333C7.22939 8.06155 5.52381 9.82486 5.52381 12Z"
        fill="currentColor"
      />
      <path
        d="M7.80952 16.7261L11.619 14.4523V15.9384H14.6667C16.7706 15.9384 18.4762 14.1751 18.4762 12C18.4762 10.3049 17.4403 8.85988 15.9873 8.30466L17.5589 7.36659C19.0278 8.34863 20 10.0569 20 12C20 15.0452 17.6122 17.5138 14.6667 17.5138H11.619V19L7.80952 16.7261Z"
        fill="currentColor"
      />
    </svg>
  )
}
